module.exports = __webpack_public_path__ + "media/images/front/treatment_support/img_tutorial_new_01-4fe25931452874f13b78c607099a32b6.png";